import React, { useEffect, useMemo, useState } from 'react';
import { Typography, Chip, Popper, Fade, Box, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { formatBytes } from 'app/util/utils';
import clsx from 'clsx';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) => ({
	whiteChip: {
		color: '#fff',
		borderColor: '#fff',
	},
	redChip: {
		color: '#fff',
		borderColor: '#fff',
		backgroundColor: '#ff0000'
	},
}));

const getDate = jsDate => {
	const date = jsDate.getDate();
	const month = jsDate.getMonth() + 1;
	const year = jsDate.getFullYear();

	return `${date}/${month}/${year}`;
};

function LicenseType(props) {
	const classes = useStyles();
	const history = useHistory();
	const user = useSelector(({ auth }) => auth.user);
	const { t } = useTranslation('fuse-layout');
	const [open, setOpen] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const licenseDates = useMemo(() => {
		console.log('user', user);
		if (!user.license) return null;

		return {
			startedAt: getDate(new Date(user.license.startTime)),
			expiresAt: getDate(new Date(user.license.endTime))
		};
	}, [user]);

	const handleNoLicenseClick = () => {
		history.push('/pricing')
	}

	if (!user.license) {
		return (
			<div className={clsx('text-11 capitalize')}>
				<Chip
					className={clsx(classes.redChip)}
					label={t('licenseType.noLicense')}
					variant="outlined"
					size="small"
					clickable
					onClick={handleNoLicenseClick}
				/>
			</div>
		);
	}

	return (
		<>
			<div className={clsx(classes.whiteChip, 'text-11 capitalize')}>
				<Chip
					className={clsx(classes.whiteChip, 'font-bold')}
					label={user.license.plan ? user.license.plan.groupTitle : 'No License'}
					variant="outlined"
					size="small"
					onClick={event => {
						setAnchorEl(event.currentTarget);
						setOpen(previousOpen => !previousOpen);
					}}
				/>
			</div>
			<Popper open={open} anchorEl={anchorEl} transition>
				{({ TransitionProps }) => (
					<Fade {...TransitionProps} timeout={350}>
						<Box className="border-2 bg-lime-100 p-8">
							{user.licenseSummary.memory ? (
								<Typography className="text-11 font-bold leading-5" color="textSecondary">
									{`${t('licenseType.ram') + user.licenseSummary.memory}MB`}
								</Typography>
							) : null}
							<Typography className="text-11 font-bold leading-5" color="textSecondary">
								{`${t('licenseType.queries') + user.licenseSummary.remainedQueries} / ${user.licenseSummary.initialQueries}`}
							</Typography>
							<Typography className="text-11 font-bold leading-5" color="textSecondary">
								{`${t('licenseType.customModel') + user.licenseSummary.remainedGpu}h / ${user.licenseSummary.initialGpu}h`}
							</Typography>
							<Typography className="text-11 font-bold leading-5" color="textSecondary">
								{`${t('licenseType.diskSpace') + formatBytes(user.licenseSummary.remainedDiskSpace)} / ${formatBytes(
									user.licenseSummary.initialDiskSpace
								)}`}
							</Typography>
							<Typography className="text-11 font-bold leading-5" color="textSecondary">
								{`${t('licenseType.startDate') + licenseDates.startedAt}`}
							</Typography>
							<Typography className="text-11 font-bold leading-5" color="textSecondary">
								{`${t('licenseType.endDate') + licenseDates.expiresAt}`}
							</Typography>
							{/* <Typography className="text-11 font-bold leading-5" color="textSecondary"> */}
							{/*	{t('licenseType.hasCustomService')} */}
							{/*	{user.userLicense.aggregationLimit ? <span>&#10004;</span> : <span>&#9747;</span>} */}
							{/* </Typography> */}
						</Box>
					</Fade>
				)}
			</Popper>
		</>
	);
}

export default LicenseType;
